import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import styles from "./button.module.css";
import { ButtonType } from "../../../";
import { UiButton } from "@ui-monorepo/index";
import { TemplateType, ProductType, ITheme } from "@commons-monorepo/index";

interface ButtonProps {
  productType?: ProductType;
  isDisabled?: boolean;
  onClick: () => void;
  theme: ITheme;
}

const Button: FC<ButtonProps> = ({
  productType,
  isDisabled,
  theme,
  onClick
}) => {
  const { t } = useTranslation();
  const cardType = theme.template.PRODUCT_CARD;
  const isService = productType === ProductType.Service;

  const buttonType = useMemo(() => {
    switch (cardType) {
      case TemplateType.PRODUCT_CARD_2:
        return ButtonType.Button1;
      case TemplateType.PRODUCT_CARD_3:
        return ButtonType.Button2;
      case TemplateType.PRODUCT_CARD_4:
        return ButtonType.Button2;
      case TemplateType.PRODUCT_CARD_5:
        return ButtonType.Button2;
      case TemplateType.PRODUCT_CARD_6:
        return ButtonType.Button2;
      case TemplateType.PRODUCT_CARD_7:
        return ButtonType.Button3;
      default:
        return ButtonType.Button1;
    }
  }, [cardType]);

  const handleButtonClick = (e?: React.MouseEvent<HTMLButtonElement>) => {
    !isDisabled && onClick();
    e?.stopPropagation();
    e?.preventDefault();
  };

  return buttonType === ButtonType.Button2 ?
  <UiButton
    theme={theme}
    specialShortCase
    className={`${styles.buttonWrapper} ${styles.customButton}`}
    rightIcon={
    <span className={`${theme.config?.button?.icon || "icon-cart"}`} />}

    hasPersonalization
    isFilled
    onClick={handleButtonClick} /> :


  <UiButton
    isFilled
    theme={theme}
    className={`${styles.buttonWrapper} ${styles[buttonType]}`}
    onClick={handleButtonClick}>

      {[ButtonType.Button1, ButtonType.Button3].includes(buttonType) &&
    <>
          <span className={styles.buyProductText}>
            {t(isService ? "button.service" : "button.add")}
          </span>
          <span
        className={`${styles.icon} ${
        isService ?
        "icon-calendar" :
        theme.config?.button?.icon || "icon-cart"
        }`} />

        </>}

      {[ButtonType.Button2].includes(buttonType) &&
    <span className={`${theme.config?.button?.icon || "icon-cart"}`} />}

    </UiButton>;

};

export default Button;